import React from "react";
import {
  Settings,
  Mail,
  PanelLeft,
} from "lucide-react"; // modern icons
import '../index.css';

export default function WhyChoose() {
  const features = [
    {
      title: "Setup Guidance!",
      desc: "Get expert step-by-step assistance to launch your website smoothly. From domain setup to server configuration — we guide you every step of the way.",
      icon: <Settings size={50} className="text-blue-500 drop-shadow" />,
    },
    {
      title: "Free Emails",
      desc: "Create professional email addresses that match your domain — at no extra cost. Stay connected and build trust with your clients effortlessly.",
      icon: <Mail size={50} className="text-blue-500 drop-shadow" />,
    },
    {
      title: "cPanel Control",
      desc: "Manage your hosting with ease using the powerful cPanel dashboard. Enjoy full control over your files, emails, databases, and security — all in one place.",
      icon: <PanelLeft size={50} className="text-blue-500 drop-shadow" />,
    },
  ];
  

  return (
    <section className="bg-gray-50 py-16" id="why-choose">
      <div className="container mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-12">
          {/* <h5 className="text-gray-500 uppercase tracking-widest mb-2">
            Why Choose
          </h5> */}
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-800">
            Why Choose Us?
          </h2>
        </div>

        {/* Feature Grid */}
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="relative bg-white border border-gray-200 rounded-xl shadow hover:shadow-lg transition-shadow duration-300 p-6 flex items-start gap-5"
            >
              {/* Ribbon */}
              {feature.ribbon && (
                <div className="absolute -top-3 left-4 bg-gray-800 text-white text-xs uppercase px-3 py-1 rounded-md shadow">
                  {feature.ribbon}
                </div>
              )}

              {/* Icon */}
              <div className="flex-shrink-0">{feature.icon}</div>

              {/* Text */}
              <div>
                <h4 className="text-lg font-semibold text-blue-600 mb-2">
                  {feature.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
